/**
 * 系统管理 菜单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '../charts/statistics' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <el-row>
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column prop="type" label="类型" width="50" align="center" >
        </el-table-column>
        <el-table-column prop="title" label="标题" width="150" align="center" >
        </el-table-column>
        <el-table-column prop="text" label="内容" width="200" align="center" >
        </el-table-column>
        <el-table-column prop="phone" label="电话号码" width="100" align="center" >
        </el-table-column>
        <el-table-column prop="visible" label="可跳转" width="50" align="center" >
        </el-table-column>
        <el-table-column prop="shopId" label="店铺id" width="80" align="center" >
        </el-table-column>
        <el-table-column align="center" label="图片" min-width="200">
          <template slot-scope="scope">
            <img style="width: 50%; height: auto;"  v-for="item in scope.row.img" :src="item" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="50">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- title -->
      <div class="modt-box">添加广告</div>
      <el-col :span="4"> </el-col>
      <el-col :span="18">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="类型" prop="type">
            <el-select size="small" v-model="form.type" placeholder="请选择" class="selectw">
              <el-option v-for="parm in fmenu" :key="parm.id" :label="parm.name" :value="parm.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input size="small" v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="首页" prop="first">
            <el-input size="small" v-model="form.first"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="img">
            <el-input size="small" v-model="form.img"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="text">
            <el-input size="small" v-model="form.text"></el-input>
          </el-form-item>
          <el-form-item label="电话号码" prop="phone">
            <el-input size="small" v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="可跳转" prop="visible">
            <el-switch v-model="form.visible" active-color="#13ce66" inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
          <el-form-item label="店铺id" prop="shopId">
            <el-input size="small" v-model="form.shopId"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="saveModule('form')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {adminiMainAd,deleteMainAd,addMainAd,PictureServer} from '../../api/userMG'
import qs from 'qs'
export default {
  data() {
    return {
      showdelete: false,
      listData: [],
      form: {
        type: 0,
        title: '',
        first: '',
        img: '',
        text: '',
        phone: '',
        shopId: '',
        visible:false
      },
      // rules表单验证
      rules: {
        title: [
          { required: true, message: '标题必填', trigger: 'blur' }
        ],
        first: [
          { required: true, message: '首页图必填', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '图片列表必填', trigger: 'blur' }
        ],
        text: [{ required: true, message: '内容必填', trigger: 'blur' }]
      },
      fmenu: [{id:0,name:"首页"},{id:1,name:"商家"}]
    }
  },
  /**
   * 创建完毕
   */

  created() {
    this.getdata()
  },
  methods: {
    // 获取数据
    getdata() {
      this.loading = true
      adminiMainAd().then(res => {
        if (res.state == 200) {
          for(var i=0;i<res.data.ad.length;i++){
            var img_list=[res.data.ad[i][1]]
            res.data.ad[i][2].split(",").forEach(e=>{
              img_list.push(e)
            })
            this.listData.unshift({id:res.data.ad[i][0],title:res.data.ad[i][3],text:res.data.ad[i][4],phone:res.data.ad[i][5],visible:res.data.ad[i][6]?"是":"否",shopId:res.data.ad[i][7],type:res.data.ad[i][8]?"运营":"首页",img:img_list})
          }
          this.loading = false
        }
      })
    },
    // 删除广告
    deleteUser(index, id) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteMainAd(id).then(res => {
          if (res.state == 200) {
            this.$message({
              type: 'success',
              message: '已删除!'
            })
            this.listData.splice(index,1)
            this.loading = false
          }
        })
      })
    },
    // 保存菜单
    saveModule(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.$confirm('确定要提交吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            this.loading = true
            addMainAd(this.form).then(res => {
              if (res.state == 200) {
                this.$message({
                  type: 'success',
                  message: '提交成功!'
                })
                this.loading = false
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style>
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Module.vue